// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"00639338","453":"29c41bcd","455":"8c44a839","977":"304c9b6f"}[chunkId] + ".chunk.js";
};